// plugins/watermark.js
import Vue from 'vue'

// 创建水印 canvas
const createWatermark = (text, width, height, rotate, opacity) => {
  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')

  ctx.font = '14px Arial'
  ctx.fillStyle = 'rgba(0, 0, 0, ' + opacity + ')'
  ctx.rotate((Math.PI / 180) * rotate)
  ctx.fillText(text, width / 10, height / 2)

  return canvas.toDataURL('image/png')
}
export default {
  inserted(el, binding) {
    const {
      text = '水印文本',
      width = 200,
      height = 150,
      rotate = -20,
      opacity = 0.1,
    } = binding.value || {}
    const watermarkUrl = createWatermark(text, width, height, rotate, opacity)

    // 设置水印样式
    const style = document.createElement('style')
    style.type = 'text/css'
    style.textContent = `
      .watermark::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        background-image: url('${watermarkUrl}');
        background-repeat: repeat;
        z-index: 9999;
      }
    `
    document.head.appendChild(style)

    // 应用水印类
    el.classList.add('watermark')
    el.style.position = 'relative'
  },
}
